import styles from "./styles.module.scss";
import { AppointmentCardSkeleton } from "./appointmentCard";

export function AppointmentTableSkeleton() {
  return (
    <div className={styles.container}>
      <div className={styles.body}>
        {[...Array(3).keys()].map((key) => {
          return <AppointmentCardSkeleton key={key} />;
        })}
      </div>
    </div>
  );
}
